import baseballismWhite from "./logos/baseballism-white.webp?url";
import cozyEarthWhite from "./logos/cozy-earth-white.webp?url";
import malbonWhite from "./logos/malbon-white.webp?url";
import nikeStrengthWhite from "./logos/nike-strength-white.webp?url";
import popflexWhite from "./logos/popflex-white.webp?url";
import portlandLeatherWhite from "./logos/portland-leather-white.webp?url";
import wolfpakWhite from "./logos/wolfpak-white.webp?url";

/** Merchant logos shown over the dark login/onboarding hero panel. */
export const LOGIN_LOGO_POOL: readonly { name: string; src: string }[] = [
  { name: "popflex", src: popflexWhite },
  { name: "nike strength", src: nikeStrengthWhite },
  { name: "baseballism", src: baseballismWhite },
  { name: "wolfpak", src: wolfpakWhite },
  { name: "portland leather", src: portlandLeatherWhite },
  { name: "cozy earth", src: cozyEarthWhite },
  { name: "malbon", src: malbonWhite },
];
